// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"18fd209a","413":"0d11e11d","963":"d4a209aa","973":"7bb0c87a"}[chunkId] + ".chunk.js";
};